import EntityBaseRepository from '@/api/EntityBaseRepository';
import { ActuatorType } from '@/models/actuatorType';
import { AxiosResponse } from 'axios';
import { log } from 'console';

export default class ActuatorTypeRepository extends EntityBaseRepository {

    public getAllActuatorTypes(): Promise<AxiosResponse> {
        return this.axiosClient.get('/actuatorType');
    }

    public getActuatorType(id: string): Promise<AxiosResponse> {
        return this.axiosClient.get(`/actuatorType/${id}`);
    }

    public createActuatorType(actuatorType: ActuatorType): Promise<AxiosResponse> {
        return this.axiosClient.post('/actuatorType', actuatorType);
    }

    public updateActuatorType(actuatorType: ActuatorType): Promise<AxiosResponse> {
        console.log('updateActuatorType', actuatorType);
        return this.axiosClient.put(`/actuatorType/${actuatorType.id}`, actuatorType);
    }

    public deleteActuatorType(id: string): Promise<AxiosResponse> {
        return this.axiosClient.delete(`/actuatorType/${id}`);
    }

    // public getMaintenanceListElementsByActuatorType(actuatorTypeId: string): Promise<AxiosResponse> {
    //     return this.axiosClient.get(`/actuatorType/maintenanceListElements/${actuatorTypeId}`);
    // }
}
